module.exports = __webpack_public_path__ + "static/media/HBCH-USDT.a4d8135e.svg";